import { Header, Footer } from '@webmotors/consumer-shared-ui';
import { useLayout } from './layout.hook';
import { layoutStyles } from './layout.styles';
import type { TLayoutConfig } from './layout.types';

const Layout = ({ children }: TLayoutConfig) => {
	const { authToken, portalBaseUrl, footerConfig } = useLayout();

	return (
		<>
			<Header authToken={authToken} baseUrl={portalBaseUrl} />
			<main className={layoutStyles.content}>{children}</main>
			<Footer {...footerConfig} />
		</>
	);
};

Layout.displayName = 'Layout';

export { Layout };
